import * as Utils from '../../utils/utils';
import constants from '../../utils/constants';

/**
 * Sets up configuration object with default values and additional properties.
 * @param {Object} _config - The configuration object.
 * @param {string} _config.requester - The requester.
 * @param {string} _config.productId - The product ID.
 * @param {string} _config.zone - The zone.
 * @param {string} [_config.url] - The URL.
 * @param {Object} [_config.params] - The additional parameters.
 * @returns {Object|boolean} The configuration object or false if required properties are missing.
 */
const setupConfig = (_config) => {
  if (!_config || !_config.requester || !_config.productId || !_config.zone) {
    return false;
  }

  const config = {
    ..._config.params,
    ...{
      visitorId: Utils.getVisitorId(),
      countryCode: Utils.getCountryCode(),
      zipCode: Utils.getZipCode(),
      stateCode: Utils.getStateCode(),
      customerId: Utils.getCustomerId(),
      adobeVisitorId: Utils.getAdobeVisitorId(),
      searchTerm: Utils.getSearchedTerm(),
      customerType: Utils.getCustomerType(),
      _customerExperiment: Utils.getExperimentIdsFromSeedCookie(),
    },
    ..._config,
  };

  const { zone, url } = config;
  if (zone.toUpperCase().includes('HP')) {
    config.zone = zone.toUpperCase();
    if (url && url.toUpperCase().includes(constants.UPC_BOPS_PURCHASABLE)) {
      config.storeNumber = Utils.getCustomerShipLocation();
    }
    config.facetFilters = Utils.facetFiltersForHPZone(url);
  } else {
    config.facetFilters = Utils.facetFilters();
  }

  if (!config.timeout) {
    config.timeout = 15000;
  }
  return config;
};

export default setupConfig;
